import { render, staticRenderFns } from "./VPanel.vue?vue&type=template&id=55fad848"
import script from "./VPanel.vue?vue&type=script&lang=js"
export * from "./VPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports